// extracted by mini-css-extract-plugin
export default {"headerView":"headerView_headerView__YyQjC","content":"headerView_content__pahJH"};